export const readAwsBucketName = ({
  target,
  details,
}: {
  target: string;
  details?: Record<string, unknown>;
}): string | null => {
  const normalizedTarget = target.trim();

  if (/^arn:aws:s3:::[^/]+$/i.test(normalizedTarget)) {
    return normalizedTarget.split(':::')[1]?.split('/')[0] ?? null;
  }

  if (/^[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/.test(normalizedTarget)) {
    return normalizedTarget;
  }

  const fromDetails = details?.bucketName;

  if (typeof fromDetails === 'string' && fromDetails.trim().length > 0) {
    return fromDetails.trim();
  }

  return null;
};
